export class Funcionario {
  idFuncion: number;
  nome: string;
  email: string;
  liberado: boolean;
  celular: string;
  fone: string;
  perfil: number;
  limDesc: number;
  verCustos: string;
  situacao: boolean;
  cep: string;
  cpf: string;
  vendedor: number;
  nomeComp: string;
  status: number;
  rg: string;
  orgao: string;
  endereco: string;
  num: number;
  compl: string;
  bairro: string;
  cidade: string;
  estado: string;
  dtNasc: Date;
  dtAdmissao: Date;
  comissao: number;
  alteraVendedor: boolean;
  foto: any;
  fotoBase64: string;
  superior: number;
  funilPadrao: number;
  bloquearCheck: boolean;
  checado: boolean;
  codErp: string;
  editaPedido: boolean;
  verExcel: boolean;
  podeEditarVendaDireta: boolean;
  perfisDeAcesso: number[];
  telasDeAcesso: number[];
  relatoriosDeAcesso: number[];
  setores: number[];
  podeEditarFrete: boolean;
  podeEditarServicoEntrega: boolean;
  podeEditarSeguro: boolean;
  podeDescontoIndividual: boolean;
  podeVerTotaisMonitores: boolean;
  idCDPadrao: number;
  podeAlterarLiderTime: boolean;
  podeGerarCombAut: boolean;
  podeAlterarEstoque: boolean;
  verGestaoAvancada: boolean;
  podeVerEstoque: boolean;
  filasGestao: number[];
  podeVerMensagem: boolean;
  podeVerMarkup: boolean;
  podeAlterarCD: boolean;
  podeVerPesquisaGeral: boolean;
  podeVerAnaliseCredito: boolean;
}


